import { addLead } from "../services/api.js";

document.addEventListener("DOMContentLoaded", () => {
    const contactForm = document.getElementById("contactForm");
    if (!contactForm) return;

    const contactName = document.getElementById("contactName");
    const contactPhone = document.getElementById("contactPhone");
    const contactLocation = document.getElementById("contactLocation");
    const contactLoanAmount = document.getElementById("contactLoanAmount");

    contactForm.addEventListener("submit", async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!validateForm()) return;

        const submitButton = contactForm.querySelector("[type='submit']");
        submitButton.classList.add("loading");
        submitButton.setAttribute('disabled', true)
        submitButton.innerHTML = 'Sending...';

        const payload = {
            name: contactName.value.trim(),
            phone: contactPhone.value.trim(),
            location: contactLocation.value.trim(),
            loanAmount: contactLoanAmount.value.trim(),
        };

        console.log({ payload });


        const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbw4ovVNcbTL3_NdNWN5jOhABj0hjjxP-wqpSv6QOnXBwHuTowmMTMDTVc1muuC-5HMnGg/exec';

        fetch(GOOGLE_SCRIPT_URL, {
            method: "POST",
            body: JSON.stringify(payload)
        })
            .then(() => {
                submitButton.removeAttribute('disabled');
                submitButton.classList.remove("loading");
                submitButton.innerHTML = 'Submit';
                contactForm.reset();
                // window.location.href = '/thankyou.html'

                Swal.fire({
                    text: "Form submitted successfully!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 3000,
                });

            })
            .catch(() => alert("Submission failed"))




        try {
            // const res = await addLead(payload); // await API call
            // console.log("API Response:", res);

            // if (res) {
            //     Swal.fire({
            //         text: "Form submitted successfully!",
            //         icon: "success",
            //         showConfirmButton: false,
            //         timer: 3000,
            //     });
            //     contactForm.reset();
            // } else {
            //     throw new Error("Invalid response");
            // }
        } catch (error) {
            // console.error("API Error:", error);
            // Swal.fire({
            //     title: "Oops...",
            //     text: `${error?.response?.data?.issues?.message}` || "Something went wrong!",
            //     icon: "error",
            //     showConfirmButton: true,
            // });
        } finally {
            // submitButton.classList.remove("loading");
        }
    });

    // 🔁 Real-time validation
    contactForm.addEventListener("input", (event) => {
        const target = event.target;
        if (target.tagName.toLowerCase() === "input") {
            validateField(target);
        }
    });

    // =========================
    // ✅ Validation Functions
    // =========================
    function validateForm() {
        let isValid = true;
        [contactName, contactPhone, contactLocation, contactLoanAmount].forEach((field) => {
            isValid = validateField(field) && isValid;
        });
        return isValid;
    }

    function validateField(field) {
        const fieldName = field.name;
        const fieldValue = field.value.trim();
        const errorSpan = document.getElementById(`${fieldName}Error`);
        const formControl = field.parentElement;

        let fieldMap = {
            contactName: "Name",
            contactPhone: "Mobile Number",
            contactLocation: "Location",
            contactLoanAmount: "Loan Amount",
        }

        errorSpan.textContent = "";
        formControl.classList.remove("error");

        if (!fieldValue) {
            errorSpan.textContent = `${capitalize(fieldMap[fieldName])} is required`;
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "contactName" && !isValidName(fieldValue)) {
            errorSpan.textContent = "Invalid name";
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "email" && !isValidEmail(fieldValue)) {
            errorSpan.textContent = "Invalid email address";
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "contactPhone" && !isValidMobile(fieldValue)) {
            errorSpan.textContent = "Invalid mobile number";
            formControl.classList.add("error");
            return false;
        }

        return true;
    }

    function isValidName(name) {
        return /^[a-zA-Z\s]{3,}$/.test(name);
    }

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function isValidMobile(mobile) {
        return /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/.test(mobile);
    }

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
});
